/* eslint-disable no-useless-escape */
/* eslint-disable import/no-webpack-loader-syntax */

import React from "react";
import { Code } from "rebass";
import Heading from "../components/Heading";
import Exercise from "../components/Exercise";
import Theory from "../components/Theory";
import P from "../components/P";
import SH from "../components/SH";
import Toc from "../components/Toc";
import ButtonLink from "../components/ButtonLink";

const Page = () => (
    <div>
        <Toc active="validation" />
        <Heading fontSize={5}>Validation</Heading>
        <Theory>
            <P>Some words about validation.</P>
        </Theory>
        <P>
            One important piece that is left is to validate the data that comes
            from the user.
        </P>
        <P>We would like to validate things like:</P>
        <ul>
            <li>The name of the user must have at least 2 characters.</li>
            <li>The email of the user is a valid email string.</li>
            <li>We don't sell more tickets than what we have available.</li>
        </ul>
        <P>
            For that, we can use the Validator component. We already installed
            it when we were building our forms.
        </P>
        <P>Let's add some validation constraints in the Enquiry Entity:</P>
        <SH code={require("raw-loader!./code/entity-enquiry-2.txt")} />
        <P>That is it, we are now enforcing these restrictions.</P>
        <Exercise code={require("raw-loader!./code/entity-sale-2.txt")}>
            <P>
                Can you add a validation constraint in Sale so{" "}
                <Code>fullName</Code> has at least 2 characters?
            </P>
        </Exercise>
        <P>
            We can create our own constraints, even when they are complicated.
            Let's see an example:
        </P>
        <P>
            We would like to apply a validation constraint in our form so it is
            not valid if the number of free seats is less than the amount that
            the user wants to book.
        </P>
        <P>
            To build a validator, we need to write two objects: a Constraint and
            a Validator. This is similar to the pattern we saw previously with
            Events and EventListeners.
        </P>
        <P>The Constraint will hold the data.</P>
        <P>The Validator will contain the actual logic of the validation.</P>
        <P>
            Let's create a new directory <Code>src/Validator/Constraint</Code>.
        </P>
        <P>
            In there, we will write a new file{" "}
            <Code>src/Validator/Constraint/HasAvailableSeats.php</Code>:
        </P>
        <SH code={require("raw-loader!./code/validator-constraint.txt")} />
        <P>
            And the validator in{" "}
            <Code>src/Validator/Constraint/HasAvailableSeatsValidator.php</Code>:
        </P>
        <SH code={require("raw-loader!./code/validator.txt")} />
        <P>
            Can you guess how this works? Validator will call a method in the
            Entity Movie to get the number of available seats, and if there are
            not enough seats, it will add a violation using our constraint
            message.
        </P>
        <P>
            The logic to get the number of available seats is better placed in
            the entity Movie. Whenever there is logic that is related to the
            entities, and not to external services, a good place to put it is in
            the Entity:
        </P>
        <SH code={require("raw-loader!./code/entity-movie-numseats.txt")} />
        <P>
            Now, how to use it from our Form? Let's update <Code>SaleType</Code>:
        </P>
        <P>(The only changes are in lines 10, 30 and 41)</P>
        <SH code={require("raw-loader!./code/type-sale-2.txt")} />
        <P>
            Line 41 allows us now to pass <Code>movie</Code> as an option when we build the
            form in our Controller:
        </P>
        <SH
            code={`
        $form = $this->createForm(SaleType::class, $sale, ['movie' => $movie]);
        `}
        />
        <P>
            Try it booking more than 25 tickets in several sales of the same movie, does it work?
        </P>
        <P>
            This was just an example to show that we can integrate whatever rule
            we think about in our validations.
        </P>
        <ButtonLink to="/testing" title="Go to next section"/>
    </div>
);

export default Page;



// WEBPACK FOOTER //
// ./src/pages/validation.js